import addClass from '../../general/class/addClass';
import insertAfter from '../../general/insertAfter';

import * as exBootstrap from '../../bootstrap';
import * as exElement from '../../utils/element';

import type { IToastContainerConfig } from './types';
import { toastSource } from './source';

// ----------------------------------------------------------------------------

function createToastContainer(config: IToastContainerConfig = {}): HTMLElement {
    // Create element (toast container)
    const elToastContainer = exElement.create({
        merge: config,
        class: {
            new: 'toast-container',
        },
    });

    // ------------------------------------------------------------------------

    // If using placement
    if (config.placement && typeof config.placement === 'string') {
        addClass(elToastContainer, toastSource.placement[config.placement]);
    }

    // ------------------------------------------------------------------------

    // Return
    return elToastContainer;
}

function alreadyToastContainer(element: HTMLElement, config: IToastContainerConfig = {}): HTMLElement {
    let find: string | undefined;

    // If using placement
    if (config.placement != null) {
        find = '.' + toastSource.placement[config.placement];
    }

    // Get element (toast container)
    let elToastContainer = document.querySelector<HTMLElement>('.toast-container' + find);

    // If there is element (toast container)
    if (elToastContainer) {
        elToastContainer.appendChild(element);
    }
    // If there is no element (toast container)
    else {
        // Create element (toast container)
        elToastContainer = createToastContainer(config);

        // If there is element parent
        if (element.parentNode) {
            insertAfter(elToastContainer, element);
        }

        elToastContainer.appendChild(element);
    }

    // Return
    return elToastContainer;
}

// ----------------------------------------------------------------------------

function show(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.show('Toast', element, config);
}

function hide(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.hide('Toast', element, config);
}

function dispose(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.dispose('Toast', element, config);
}

// ----------------------------------------------------------------------------

function resetTimeout(element: HTMLElement): void {
    const bsToast = exBootstrap.getCreateInstance('Toast', element);
    if (!bsToast) {
        return;
    }

    // Reset
    bsToast._clearTimeout();
    bsToast._maybeScheduleHide();
}

// ----------------------------------------------------------------------------

export { createToastContainer, alreadyToastContainer, show, hide, dispose, resetTimeout };
